import React from 'react';
import { Modal } from "@ignitesales/neuro-application/src/neuro-ui";
import { NeuroMessage, useProduct, useNeuroMessages } from '@ignitesales/neuro-application';
import { renderProductAddOns, renderProductFeatures, renderProductDisclosures } from '../utils/recPageFunctions';

const ProductModal = ({ active, onCloseModal, product, bankSelected}) => {
  const { name } = useProduct(product);

return <Modal
    show={ active }
    className={`${bankSelected} productModal`}
    title={ <h1>{name}</h1> }
    onClose={ onCloseModal }
    nodeId="root"
    closeBtn={ <i className="fa fa-close"/> }
  >
    <div className="product-modal">
        <div className="product-modal-info">
            <NeuroMessage id={product.id.toString() + ".description"} tagName="span" />
        </div>
        <div className="product-modal-features">
            {renderProductFeatures(product.id)}
        </div>
        <div className="product-modal-disclosures">
            {renderProductDisclosures(product.id)}
        </div>
        <div className="product-modal-addOnProducts">
            {renderProductAddOns(product)}
        </div>
    </div>
  </Modal>;
};

export default ProductModal;
